module.exports = __webpack_public_path__ + "img/osm-icon.3fd05ad7.svg";